module.exports = __webpack_public_path__ + "static/media/sample.87e68067.srt";